"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Int32AnalyticsItem model module.
 * @module model/Int32AnalyticsItem
 * @version 1.1.3-alpha.1
 */
class Int32AnalyticsItem {
  /**
   * Constructs a new <code>Int32AnalyticsItem</code>.
   * @alias module:model/Int32AnalyticsItem
   */
  constructor() {
    Int32AnalyticsItem.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>Int32AnalyticsItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Int32AnalyticsItem} obj Optional instance to populate.
   * @return {module:model/Int32AnalyticsItem} The populated <code>Int32AnalyticsItem</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Int32AnalyticsItem();
      if (data.hasOwnProperty('value')) {
        obj['value'] = _ApiClient.default.convertToType(data['value'], 'Number');
      }
      if (data.hasOwnProperty('previousVal')) {
        obj['previousVal'] = _ApiClient.default.convertToType(data['previousVal'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Int32AnalyticsItem</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Int32AnalyticsItem</code>.
   */
  static validateJSON(data) {
    return true;
  }
}

/**
 * @member {Number} value
 */
Int32AnalyticsItem.prototype['value'] = undefined;

/**
 * @member {Number} previousVal
 */
Int32AnalyticsItem.prototype['previousVal'] = undefined;
var _default = Int32AnalyticsItem;
exports.default = _default;